import Component from '../core/Component'
import scrollToElement from '../services/Viewport/scrollToElement'

const defaults = {
    offset: 20
}

export default class CourseScrollTo extends Component {
    constructor(element) {
        super(element, defaults)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const id = this.element.href.split('#')[1]

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        scrollToElement(element, this.options.offset)
    }

}